import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const CARDS = [
    { c: 'oklch(0.63 0.17 212)', t: 'Start at 60%, not zero', d: 'AI auto-populates ~60% of diligence from documents your client already holds.' },
    { c: 'oklch(0.61 0.20 248)', t: 'AI makes you indispensable', d: 'You become the trusted conductor: structured, verified, human-reviewed evidence no generic LLM can match.' },
    { c: 'oklch(0.58 0.19 277)', t: 'Surface billable work', d: 'Quarterly reviews flag gaps and upsell opportunities across your portfolio — by design, not by accident.' },
    { c: 'oklch(0.56 0.20 302)', t: 'Your whole client book', d: 'Investment, Growth and Exit Ready modules — useful for the 80% of clients not currently raising.' },
    { c: 'oklch(0.60 0.21 328)', t: 'Prove your value visibly', d: 'Bronze, Silver and Gold certification puts your impact on the dashboard every quarter.' },
    { c: 'oklch(0.64 0.19 354)', t: 'Free advisor account', d: 'Zero cost, no licence, no revenue share. Only your clients pay — and they get 20% off Pro.' },
    { c: 'oklch(0.68 0.18 22)', t: 'Investor-grade credibility', d: "Hand a VC a certified Diligence Pack alongside the deck — answers to questions they hadn't asked." },
    { c: 'oklch(0.70 0.16 44)', t: 'Be found by new clients', d: 'Your AdvisorMatch profile is promoted to unaffiliated companies and 40+ VCs on the platform.' },
];

const FractionHelpSection = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(CARDS.length, { autoplayMs: 5000 });

    return (
        <section className="lp-section">
            <div className="lp-sec-head">
                <div>
                    <h2 className="lp-h2" data-lp-reveal>Why 80+ fractional CFOs are already on the platform</h2>
                    <p className="lp-sub" data-lp-reveal data-lp-delay="80">Diligentsia makes your judgment visible, scalable, and impossible to replicate without you.</p>
                </div>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous cards" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next cards" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-track" ref={trackRef}>
                        {CARDS.map((card, i) => (
                            <div className="lp-vcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 100}>
                                <div className="lp-vcard-num" style={{ background: card.c }}>{String(i + 1).padStart(2, '0')}</div>
                                <h3>{card.t}</h3>
                                <p>{card.d}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="lp-dots">
                {Array.from({ length: pages }).map((_, i) => (
                    <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to cards ${i + 1}`} onClick={() => goTo(i)} />
                ))}
            </div>
        </section>
    );
};

export default FractionHelpSection;
